/**
 * MuiTypography
 */
const MuiTypography = {
  styleOverrides: {
    h3: ({
      theme
    }) => ({
      '& .MuiSvgIcon-root': {
        color: theme.palette.secondary.main
      }
    })
  }
};
export default MuiTypography;